'use strict';

/**
 * Accepts a list of custom account-translations and a fallback name as input and returns the translated name in:
 * 1. the user language if available
 * 2. in the first found language if the user language is not available
 * 3. in the default fallback
 */
module.exports = /* @ngInject */ function (userService) {

	let user;
	let loading = false;

	/**
	 * Returns the custom account-assignment name in user lang.
	 * If user lang is not defined, the default name will be returned.
	 *
	 * @param translations {[{
	 *      type: number,
	 *		language: {
	 *		    id: number,
	 *			name: string,
	 *			description: string,
	 *			key: string,
	 *			active: boolean,
	 * 			locale: string,
	 * 			iso639LanguageAlpha2: string
	 *		},
	 *		name: string,
	 *		description: string
	 * }]}
	 * @param fallbackName {string}
	 * @param myself {{
	 *     id: string,
	 *	   login: string,
	 *	   firstName: string,
	 *	   surName: string,
	 *	   language: number,
	 *	   type: 'CUSTOMER', 'SUPPLIER', 'ADMIN'
	 * }}
	 *
	 * @returns {string}
	 */
	function getCustomAccountAssignmentTypeNameInUserLang(translations, fallbackName, myself) {
		if(translations && translations.length){
			const userLangId = myself.language.id;
			const typeNameInUserLang = translations.find(translation => translation.language === userLangId);
			if(typeNameInUserLang){
				return typeNameInUserLang.name;
			}

			return translations[0].name;
		}

		return fallbackName;

	}

	/**
	 * Returns the translated custom account-assignment type name
	 *
	 * @param translations {[{
	 *      type: number,
	 *		language: {
	 *		    id: number,
	 *			name: string,
	 *			description: string,
	 *			key: string,
	 *			active: boolean,
	 * 			locale: string,
	 * 			iso639LanguageAlpha2: string
	 *		},
	 *		name: string,
	 *		description: string
	 * }]}
	 *
	 * @param fallbackName {string}
	 *
	 * @returns {string}
	 */
	function getTranslation(translations, fallbackName) {

		if(user){
			return getCustomAccountAssignmentTypeNameInUserLang(translations, fallbackName, user);
		}

		if(!loading){
			loading = true;
			userService.getMyself.get().$promise.then((myself) => {
				user = myself;
				loading = false;
			}, (e) => {
				loading = false;
				console.error(e);
			})
		}


		return fallbackName;
	}

	return getTranslation;
}
